import { createClient } from '@supabase/supabase-js';
const SUPABASE_URL = 'https://snkbomkcyirketkczbab.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNua2JvbWtjeWlya2V0a2N6YmFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzOTU3NDMsImV4cCI6MjA5NTk3MTc0M30.qf_Dahqqhat6UC2GAlGeB5mZl4ArTdj_Le88T6dolxU';
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
// ─── AUTH ─────────────────────────────────────────────────────────────────────
export async function signUp(email, password, metadata={}) {
  const { data, error } = await supabase.auth.signUp({
    email, password,
    options: {
      emailRedirectTo: 'https://fisa-medicala.pages.dev',
      data: metadata
    }
  });
  if (error) throw error;
  return data;
}
export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}
export async function signOut() { await supabase.auth.signOut(); }
// ─── 2FA pe email (cod trimis pe email la login) ─────────────────────────────
// Steagul 2FA e stocat în user_metadata (mfa_email). Codul e generat/verificat
// de funcția serverless /claude (semnat HMAC, trimis pe email prin Resend).
export function isEmail2FAEnabled(session) {
  return session?.user?.user_metadata?.mfa_email === true;
}
export async function setEmail2FA(enabled) {
  try {
    const { error } = await supabase.auth.updateUser({ data: { mfa_email: !!enabled } });
    if (error) return { ok:false, message: error.message };
    return { ok:true };
  } catch(e) { return { ok:false, message: e.message || String(e) }; }
}
// Cere serverului să trimită un cod pe email; întoarce un token opac de verificat
export async function sendMfaCode(session) {
  try {
    const r = await fetch('/claude', {
      method:'POST',
      headers:{'Content-Type':'application/json', 'Authorization':`Bearer ${session?.access_token || ''}`},
      body: JSON.stringify({ action:'mfa_send' })
    });
    const d = await r.json();
    if (!r.ok || d.error) return { ok:false, message: d.error || 'Nu am putut trimite codul.' };
    return { ok:true, token: d.token };
  } catch(e) { return { ok:false, message: e.message || 'Eroare de rețea.' }; }
}
export async function verifyMfaCode(session, token, code) {
  try {
    const r = await fetch('/claude', {
      method:'POST',
      headers:{'Content-Type':'application/json', 'Authorization':`Bearer ${session?.access_token || ''}`},
      body: JSON.stringify({ action:'mfa_verify', token, code })
    });
    const d = await r.json();
    if (!r.ok) return { ok:false, message: d.error || 'Verificare eșuată.' };
    return { ok: !!d.ok, error: d.error };
  } catch(e) { return { ok:false, message: e.message || 'Eroare de rețea.' }; }
}
// ─── CICLU MENSTRUAL (privat, doar owner) ────────────────────────────────────
export async function loadCycle(session, profileId) {
  try {
    let q = supabase.from('cycle_data').select('*').eq('user_id', uid(session));
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data, error } = await q.order('id', { ascending: true }).limit(1);
    if (error) { console.error('loadCycle:', error); return null; }
    return data && data[0] ? (data[0].data || null) : null;
  } catch(e) { return null; }
}
export async function saveCycle(cycleData, session, profileId) {
  try {
    const userId = uid(session);
    let q = supabase.from('cycle_data').select('id').eq('user_id', userId);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data: rows } = await q.order('id', { ascending: true });
    if (rows && rows.length > 0) {
      await supabase.from('cycle_data').update({ data: cycleData, updated_at: new Date() }).eq('id', rows[0].id);
    } else {
      await supabase.from('cycle_data').insert({ user_id: userId, profile_id: profileId||null, data: cycleData });
    }
  } catch(e) { console.error('saveCycle:', e); }
}
// ─── JURNAL DIGESTIV (privat, doar owner) ────────────────────────────────────
// Aceeași schemă ca cycle_data: un rând per user/profil, cu blob JSON în `data`.
export async function loadGut(session, profileId) {
  try {
    let q = supabase.from('gut_data').select('*').eq('user_id', uid(session));
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data, error } = await q.order('id', { ascending: true }).limit(1);
    if (error) { console.error('loadGut:', error); return null; }
    return data && data[0] ? (data[0].data || null) : null;
  } catch(e) { return null; }
}
export async function saveGut(gutData, session, profileId) {
  try {
    const userId = uid(session);
    let q = supabase.from('gut_data').select('id').eq('user_id', userId);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data: rows, error: selErr } = await q.order('id', { ascending: true });
    if (selErr) { console.error('saveGut select:', selErr); return { ok:false, message: selErr.message||String(selErr) }; }
    if (rows && rows.length > 0) {
      const { error } = await supabase.from('gut_data').update({ data: gutData, updated_at: new Date() }).eq('id', rows[0].id);
      if (error) { console.error('saveGut update:', error); return { ok:false, message: error.message||String(error) }; }
    } else {
      const { error } = await supabase.from('gut_data').insert({ user_id: userId, profile_id: profileId||null, data: gutData });
      if (error) { console.error('saveGut insert:', error); return { ok:false, message: error.message||String(error) }; }
    }
    return { ok:true };
  } catch(e) { console.error('saveGut:', e); return { ok:false, message: e.message||String(e) }; }
}
// Login cu Google sau Apple (OAuth)
export async function signInWithProvider(provider) {
  const { error } = await supabase.auth.signInWithOAuth({
    provider, // 'google' sau 'apple'
    options: { redirectTo: 'https://fisa-medicala.pages.dev' }
  });
  if (error) { console.error('signInWithProvider:', error); return { ok:false, message: error.message }; }
  return { ok:true };
}
// Trimite email cu link de resetare a parolei
export async function sendPasswordReset(email) {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: 'https://fisa-medicala.pages.dev/reset'
  });
  if (error) { console.error('sendPasswordReset:', error); return { ok:false, message: error.message }; }
  return { ok:true };
}
// Setează parola nouă (după ce userul a venit din linkul de email)
export async function updatePassword(newPassword) {
  const { error } = await supabase.auth.updateUser({ password: newPassword });
  if (error) { console.error('updatePassword:', error); return { ok:false, message: error.message }; }
  return { ok:true };
}
// Șterge complet contul curent (toate datele + contul de auth) via RPC
export async function deleteMyAccount() {
  const { error } = await supabase.rpc('delete_my_account');
  if (error) {
    console.error('deleteMyAccount:', error);
    if (typeof window !== "undefined" && window.fmErr) window.fmErr('deleteMyAccount:', error.message || error);
    return { ok:false, message: error.message || String(error) };
  }
  try { await supabase.auth.signOut(); } catch(e){}
  return { ok:true };
}
export async function getSession() {
  const { data } = await supabase.auth.getSession();
  return data?.session;
}
export function onAuthChange(callback) {
  return supabase.auth.onAuthStateChange((event, session) => callback(event, session));
}
// ─── HELPERS ─────────────────────────────────────────────────────────────────
function uid(session) {
  const id = session?.user?.id;
  if (!id) console.error('uid: no user id in session');
  return id;
}
// user_id efectiv: owner-ul dacă lucrăm pe profil partajat, altfel utilizatorul curent
function effUid(session, ownerUserId=null) {
  return ownerUserId || uid(session);
}
async function dbGet(table, session, profileId, ownerUserId=null) {
  try {
    // Pentru profil partajat, filtrează după user_id-ul owner-ului; altfel după al meu
    const targetUserId = ownerUserId || uid(session);
    let q = supabase.from(table).select('*').eq('user_id', targetUserId);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data, error } = await q;
    if (error) { console.error(`${table} get:`, error); return []; }
    return data || [];
  } catch(e) { console.error(`${table} get exception:`, e); return []; }
}
// ─── PROFILES ────────────────────────────────────────────────────────────────
export async function loadProfiles(session) {
  const { data, error } = await supabase.from('profiles').select('*').eq('user_id', uid(session)).order('created_at');
  if (error) { console.error('loadProfiles:', error); return []; }
  return data || [];
}
export async function createProfile(session, name, relation='Eu', dob='', sex='') {
  const { data, error } = await supabase.from('profiles').insert({
    user_id: uid(session), name, relation, dob, sex
  }).select().maybeSingle();
  if (error) { console.error('createProfile:', error); return null; }
  return data;
}
export async function updateProfile(profileId, updates) {
  const { error } = await supabase.from('profiles').update(updates).eq('id', profileId);
  if (error) console.error('updateProfile:', error);
}
export async function deleteProfile(profileId, session=null) {
  const { error } = await supabase.from('profiles').delete().eq('id', profileId);
  if (error) { console.error('deleteProfile:', error); throw error; }
}
// ─── PATIENT ─────────────────────────────────────────────────────────────────
export async function loadPatient(session, profileId, ownerUserId=null) {
  try {
    const targetUserId = ownerUserId || uid(session);
    let q = supabase.from('patient').select('*').eq('user_id', targetUserId);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    // NU maybeSingle() — poate exista duplicat; luăm primul rând
    const { data, error } = await q.order('id', { ascending: true }).limit(1);
    if (error) { console.error('loadPatient:', error); return null; }
    return data && data[0] ? (data[0].data || null) : null;
  } catch(e) { return null; }
}
export async function savePatient(patientData, session, profileId, ownerUserId=null) {
  try {
    const userId = ownerUserId || uid(session);
    let q = supabase.from('patient').select('id').eq('user_id', userId);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    // NU folosim maybeSingle() — dacă există deja duplicate, ar arunca eroare și ar crea altul.
    const { data: rows } = await q.order('id', { ascending: true });
    if (rows && rows.length > 0) {
      // Actualizează primul rând
      await supabase.from('patient').update({ data: patientData, updated_at: new Date() }).eq('id', rows[0].id);
      // Dacă există duplicate, șterge-le pe celelalte (auto-curățare)
      if (rows.length > 1) {
        const extraIds = rows.slice(1).map(r => r.id);
        await supabase.from('patient').delete().in('id', extraIds);
      }
    } else {
      await supabase.from('patient').insert({ user_id: userId, profile_id: profileId||null, data: patientData });
    }
  } catch(e) { console.error('savePatient:', e); }
}
// ─── DOCTORS ─────────────────────────────────────────────────────────────────
export async function loadDoctors(session, profileId, ownerUserId=null) {
  const rows = await dbGet('doctors', session, profileId, ownerUserId);
  return rows.map(r => ({ ...r.data, _dbId: r.id }));
}
export async function saveDoctor(doctor, session, profileId, ownerUserId=null) {
  const payload = { ...doctor }; delete payload._dbId;
  const owner = effUid(session, ownerUserId);
  if (doctor._dbId) {
    await supabase.from('doctors').update({ data: payload }).eq('id', doctor._dbId).eq('user_id', owner);
    return doctor._dbId;
  } else {
    const { data, error } = await supabase.from('doctors').insert({ user_id: owner, profile_id: profileId||null, data: payload }).select().maybeSingle();
    if (error) console.error('saveDoctor:', error);
    return data?.id;
  }
}
export async function deleteDoctor(dbId, session, ownerUserId=null) {
  if (!dbId) return;
  const { error } = await supabase.from('doctors').delete().eq('id', dbId).eq('user_id', effUid(session, ownerUserId));
  if (error) { console.error('deleteDoctor:', error); throw error; }
}
// ─── MEDICATIONS ─────────────────────────────────────────────────────────────
export async function loadMedications(session, profileId, ownerUserId=null) {
  const rows = await dbGet('medications', session, profileId, ownerUserId);
  return rows.map(r => ({ ...r.data, _dbId: r.id }));
}
export async function saveMedication(med, session, profileId, ownerUserId=null) {
  const payload = { ...med }; delete payload._dbId;
  const owner = effUid(session, ownerUserId);
  if (med._dbId) {
    await supabase.from('medications').update({ data: payload }).eq('id', med._dbId).eq('user_id', owner);
    return med._dbId;
  } else {
    const { data, error } = await supabase.from('medications').insert({ user_id: owner, profile_id: profileId||null, data: payload }).select().maybeSingle();
    if (error) console.error('saveMed:', error);
    return data?.id;
  }
}
export async function deleteMedication(dbId, session, ownerUserId=null) {
  const { error } = await supabase.from('medications').delete().eq('id', dbId).eq('user_id', effUid(session, ownerUserId));
  if (error) { console.error('deleteMedication:', error); throw error; }
}
// ─── MED LOGS ────────────────────────────────────────────────────────────────
export async function loadMedLogs(session, profileId, ownerUserId=null) {
  const rows = await dbGet('med_logs', session, profileId, ownerUserId);
  const logs = {};
  rows.forEach(r => { logs[r.day_key] = r.log_data; });
  return logs;
}
export async function saveMedLog(dayKey, logData, session, profileId, ownerUserId=null) {
  const { error } = await supabase.from('med_logs').upsert(
    { user_id: effUid(session, ownerUserId), profile_id: profileId||null, day_key: dayKey, log_data: logData, updated_at: new Date() },
    { onConflict: 'user_id,profile_id,day_key' }
  );
  if (error) console.error('saveMedLog:', error);
}
// ─── EVENTS ──────────────────────────────────────────────────────────────────
export async function loadEvents(session, profileId, ownerUserId=null) {
  const rows = await dbGet('events', session, profileId, ownerUserId);
  const evs = {};
  rows.forEach(r => { evs[r.day_key] = r.data; });
  return evs;
}
export async function saveEventsDay(dayKey, eventsData, session, profileId, ownerUserId=null) {
  const { error } = await supabase.from('events').upsert(
    { user_id: effUid(session, ownerUserId), profile_id: profileId||null, day_key: dayKey, data: eventsData, updated_at: new Date() },
    { onConflict: 'user_id,profile_id,day_key' }
  );
  if (error) console.error('saveEvents:', error);
}
// ─── DOCUMENTS ───────────────────────────────────────────────────────────────
export async function loadDocuments(session, profileId, ownerUserId=null) {
  const rows = await dbGet('documents', session, profileId, ownerUserId);
  // Generează URL-uri semnate pentru toate fișierele dintr-un singur apel;
  // dacă semnarea eșuează, rămân URL-urile stocate (nu blocăm afișarea listei)
  const paths = rows.map(r => r.file_url ? storagePathFromUrl(r.file_url) : null);
  const signedByPath = {};
  const validPaths = paths.filter(Boolean);
  if (validPaths.length) {
    try {
      const { data } = await supabase.storage.from('documents').createSignedUrls(validPaths, SIGNED_URL_TTL);
      (data || []).forEach(d => { if (d?.path && d?.signedUrl) signedByPath[d.path] = d.signedUrl; });
    } catch(e) { console.error('loadDocuments signed URLs:', e); }
  }
  return rows.map((r, i) => {
    const display = (paths[i] && signedByPath[paths[i]]) || r.file_url || null;
    return {
      id: r.id, name: r.name, date: r.date, category: r.category,
      type: r.type, size: r.size, aiExtracted: r.ai_extracted,
      aiSummary: r.ai_summary, fileUrl: display,
      extracting: false, previewUrl: display,
      isPdf: r.name?.endsWith('.pdf'),
      addedBy: r.added_by || null, addedByName: r.added_by_name || null, addedByEmail: r.added_by_email || null
    };
  });
}
export async function saveDocument(doc, session, profileId, ownerUserId=null) {
  const { data, error } = await supabase.from('documents').insert({
    user_id: effUid(session, ownerUserId), profile_id: profileId||null,
    name: doc.name, date: doc.date, category: doc.category,
    type: doc.type, size: doc.size, ai_extracted: false,
    ai_summary: null, file_url: doc.fileUrl || null,
    added_by: doc.addedBy || null, added_by_name: doc.addedByName || null, added_by_email: doc.addedByEmail || null
  }).select().maybeSingle();
  if (error) console.error('saveDoc error:', JSON.stringify(error));
  return data?.id || null;
}
export async function updateDocument(id, updates, session, ownerUserId=null) {
  await supabase.from('documents').update({ ai_extracted: updates.aiExtracted, ai_summary: updates.aiSummary }).eq('id', id).eq('user_id', effUid(session, ownerUserId));
}
// Actualizează numele și/sau categoria unui document
export async function updateDocumentFields(id, fields, session, ownerUserId=null) {
  const payload = {};
  if(fields.name !== undefined) payload.name = fields.name;
  if(fields.category !== undefined) payload.category = fields.category;
  if(fields.type !== undefined) payload.type = fields.type;
  const { error } = await supabase.from('documents').update(payload).eq('id', id).eq('user_id', effUid(session, ownerUserId));
  if(error){ console.error('updateDocumentFields:', error); return false; }
  return true;
}
export async function deleteDocument(id, session, ownerUserId=null) {
  const { error } = await supabase.from('documents').delete().eq('id', id).eq('user_id', effUid(session, ownerUserId));
  if (error) { console.error('deleteDocument:', error); throw error; }
}
// ─── ANALYSIS DOCS ───────────────────────────────────────────────────────────
export async function loadAnalysisDocs(session, profileId, ownerUserId=null) {
  const rows = await dbGet('analysis_docs', session, profileId, ownerUserId);
  return rows.map(r => {
    let vals = r.values;
    // Coloana poate fi jsonb (array) sau text (string JSON) — normalizează la array
    if (typeof vals === 'string') {
      try { vals = JSON.parse(vals); } catch(e) { vals = []; }
    }
    if (!Array.isArray(vals)) vals = [];
    return { docId: r.doc_id, docName: r.doc_name, date: r.date, values: vals, _dbId: r.id };
  });
}
export async function saveAnalysisDoc(ad, session, profileId, ownerUserId=null) {
  const owner = effUid(session, ownerUserId);
  const { error } = await supabase.from('analysis_docs').upsert(
    { user_id: owner, profile_id: profileId||null, doc_id: ad.docId, doc_name: ad.docName, date: ad.date, values: ad.values },
    { onConflict: 'user_id,doc_id' }
  );
  if (error) {
    await supabase.from('analysis_docs').insert({ user_id: owner, profile_id: profileId||null, doc_id: ad.docId, doc_name: ad.docName, date: ad.date, values: ad.values });
  }
}
export async function deleteAnalysisDoc(docId, session, ownerUserId=null) {
  const { error } = await supabase.from('analysis_docs').delete().eq('user_id', effUid(session, ownerUserId)).eq('doc_id', docId);
  if (error) { console.error('deleteAnalysisDoc:', error); throw error; }
}
// ─── METRICS ─────────────────────────────────────────────────────────────────
export async function loadMetrics(session, profileId, ownerUserId=null) {
  const rows = await dbGet('metrics', session, profileId, ownerUserId);
  return rows.map(r => ({ date: r.date, ts_sys: r.ts_sys, ts_dia: r.ts_dia, glicemie: r.glicemie, greutate: r.greutate, saturatie: r.saturatie, puls: r.puls, temperatura: r.temperatura ?? null, source: r.source, sourceDoc: r.source_doc, addedBy: r.added_by||null, addedByName: r.added_by_name||null, addedByEmail: r.added_by_email||null, _dbId: r.id }));
}
export async function saveMetric(metric, session, profileId, ownerUserId=null) {
  const owner = effUid(session, ownerUserId);
  if (metric._dbId) {
    await supabase.from('metrics').update({ ts_sys: metric.ts_sys, ts_dia: metric.ts_dia, glicemie: metric.glicemie, greutate: metric.greutate, saturatie: metric.saturatie, puls: metric.puls, temperatura: metric.temperatura ?? null }).eq('id', metric._dbId).eq('user_id', owner);
    return metric._dbId;
  } else {
    const { data, error } = await supabase.from('metrics').insert({ user_id: owner, profile_id: profileId||null, date: metric.date, ts_sys: metric.ts_sys, ts_dia: metric.ts_dia, glicemie: metric.glicemie, greutate: metric.greutate, saturatie: metric.saturatie, puls: metric.puls, temperatura: metric.temperatura ?? null, source: metric.source || 'manual', source_doc: metric.sourceDoc || null, added_by: metric.addedBy||null, added_by_name: metric.addedByName||null, added_by_email: metric.addedByEmail||null }).select().maybeSingle();
    if (error) console.error('saveMetric:', error);
    return data?.id;
  }
}
export async function deleteMetric(dbId, session, ownerUserId=null) {
  const { error } = await supabase.from('metrics').delete().eq('id', dbId).eq('user_id', effUid(session, ownerUserId));
  if (error) { console.error('deleteMetric:', error); throw error; }
}
// ─── SYMPTOMS ────────────────────────────────────────────────────────────────
export async function loadSymptoms(session, profileId, ownerUserId=null) {
  const rows = await dbGet('symptoms', session, profileId, ownerUserId);
  return rows.map(r => ({ id: r.id, date: r.date, time: r.time, items: r.items, note: r.note, addedBy: r.added_by||null, addedByName: r.added_by_name||null, addedByEmail: r.added_by_email||null }));
}
export async function saveSymptom(symptom, session, profileId, ownerUserId=null) {
  const { data, error } = await supabase.from('symptoms').insert({
    user_id: effUid(session, ownerUserId),
    profile_id: profileId||null,
    date: symptom.date,
    time: symptom.time||null,
    items: symptom.items||[],
    note: symptom.note||null,
    added_by: symptom.addedBy||null, added_by_name: symptom.addedByName||null, added_by_email: symptom.addedByEmail||null
  }).select().maybeSingle();
  if (error) console.error('saveSymptom:', error);
  return data?.id;
}
export async function updateSymptom(id, symptom, session, ownerUserId=null) {
  const { error } = await supabase.from('symptoms').update({
    date: symptom.date,
    time: symptom.time||null,
    items: symptom.items||[],
    note: symptom.note||null
  }).eq('id', id).eq('user_id', effUid(session, ownerUserId));
  if (error) console.error('updateSymptom:', error);
}
export async function deleteSymptom(id, session, ownerUserId=null) {
  const { error } = await supabase.from('symptoms').delete().eq('id', id).eq('user_id', effUid(session, ownerUserId));
  if (error) { console.error('deleteSymptom:', error); throw error; }
}
// ─── VACCINES ────────────────────────────────────────────────────────────────
export async function loadVaccines(session, profileId, ownerUserId=null) {
  const rows = await dbGet('vaccines', session, profileId, ownerUserId);
  return rows.map(r => ({ ...r.data, _dbId: r.id }));
}
export async function saveVaccine(vaccine, session, profileId, ownerUserId=null) {
  const payload = { ...vaccine }; delete payload._dbId;
  const owner = effUid(session, ownerUserId);
  if (vaccine._dbId) {
    await supabase.from('vaccines').update({ data: payload }).eq('id', vaccine._dbId).eq('user_id', owner);
    return vaccine._dbId;
  } else {
    const { data, error } = await supabase.from('vaccines').insert({ user_id: owner, profile_id: profileId||null, data: payload }).select().maybeSingle();
    if (error) console.error('saveVaccine:', error);
    return data?.id;
  }
}
export async function deleteVaccine(dbId, session, ownerUserId=null) {
  const { error } = await supabase.from('vaccines').delete().eq('id', dbId).eq('user_id', effUid(session, ownerUserId));
  if (error) { console.error('deleteVaccine:', error); throw error; }
}
// ─── FAMILY ──────────────────────────────────────────────────────────────────
export async function loadFamily(session, profileId, ownerUserId=null) {
  const rows = await dbGet('family', session, profileId, ownerUserId);
  return rows.map(r => ({ ...r.data, _dbId: r.id }));
}
export async function saveFamily(member, session, profileId, ownerUserId=null) {
  const payload = { ...member }; delete payload._dbId;
  const owner = effUid(session, ownerUserId);
  // Plasă de siguranță: nu crea NICIODATĂ membri cu nume gol sau placeholder "Profil"
  // (previne intrările fantomă auto-create indiferent de unde vin)
  const nm = (payload.name || "").trim();
  if (!member._dbId && (!nm || nm.toLowerCase() === "profil")) {
    console.warn('saveFamily: blocat membru fără nume real:', payload);
    return null;
  }
  if (member._dbId) {
    await supabase.from('family').update({ data: payload }).eq('id', member._dbId).eq('user_id', owner);
    return member._dbId;
  } else {
    const { data, error } = await supabase.from('family').insert({ user_id: owner, profile_id: profileId||null, data: payload }).select().maybeSingle();
    if (error) console.error('saveFamily:', error);
    return data?.id;
  }
}
export async function deleteFamilyMember(dbId, session, ownerUserId=null) {
  const { error } = await supabase.from('family').delete().eq('id', dbId).eq('user_id', effUid(session, ownerUserId));
  if (error) { console.error('deleteFamilyMember:', error); throw error; }
}
// Caută legături de familie create de alții care mă includ (după email)
export async function findFamilyLinksForEmail(email) {
  const { data, error } = await supabase.rpc('find_family_links_for_email', { p_email: email });
  if (error) { console.error('findFamilyLinks:', error); return []; }
  return data || [];
}
// ─── AI SUMMARIES ────────────────────────────────────────────────────────────
export async function loadAISummary(type, session, profileId, ownerUserId=null) {
  try {
    const owner = ownerUserId || uid(session);
    let q = supabase.from('ai_summaries').select('*').eq('user_id', owner).eq('type', type);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data, error } = await q.maybeSingle();
    if (error) { console.error('loadAISummary:', error); return null; }
    return data?.data || null;
  } catch(e) { return null; }
}
export async function saveAISummary(type, summaryData, session, profileId, ownerUserId=null) {
  try {
    const owner = effUid(session, ownerUserId);
    let q = supabase.from('ai_summaries').select('id').eq('user_id', owner).eq('type', type);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data: existing } = await q.maybeSingle();
    if (existing) {
      await supabase.from('ai_summaries').update({ data: summaryData, generated_at: new Date() }).eq('id', existing.id);
    } else {
      await supabase.from('ai_summaries').insert({ user_id: owner, profile_id: profileId||null, type, data: summaryData });
    }
  } catch(e) { console.error('saveAISummary:', e); }
}
// Confirmă parola actuală (re-autentificare) — folosit înainte de a permite schimbarea parolei
export async function verifyPassword(password) {
  try {
    const { data:{ user } } = await supabase.auth.getUser();
    const email = user?.email;
    if(!email) return false;
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    return !error;
  } catch(e) { return false; }
}
// ─── NOTIFICATION SETTINGS ───────────────────────────────────────────────────
const DEFAULT_NOTIF_SETTINGS = {
  enabled: true, med_time_enabled: true, med_stock_enabled: true, appt_enabled: true,
  stock_days_before: 3, appt_hours_before: 24, sound: 'default', quiet_from: null, quiet_to: null,
};
export async function loadNotificationSettings(session, profileId, ownerUserId=null) {
  try {
    const owner = ownerUserId || uid(session);
    let q = supabase.from('notification_settings').select('*').eq('user_id', owner);
    if (profileId) q = q.eq('profile_id', profileId);
    else q = q.is('profile_id', null);
    const { data, error } = await q.maybeSingle();
    if (error) { console.error('loadNotificationSettings:', error); return { ...DEFAULT_NOTIF_SETTINGS }; }
    return data ? { ...DEFAULT_NOTIF_SETTINGS, ...data } : { ...DEFAULT_NOTIF_SETTINGS };
  } catch(e) { return { ...DEFAULT_NOTIF_SETTINGS }; }
}
export async function saveNotificationSettings(settings, session, profileId, ownerUserId=null) {
  try {
    const owner = effUid(session, ownerUserId);
    const payload = {
      user_id: owner, profile_id: profileId||null,
      enabled: settings.enabled, med_time_enabled: settings.med_time_enabled,
      med_stock_enabled: settings.med_stock_enabled, appt_enabled: settings.appt_enabled,
      stock_days_before: settings.stock_days_before, appt_hours_before: settings.appt_hours_before,
      sound: settings.sound, quiet_from: settings.quiet_from||null, quiet_to: settings.quiet_to||null,
      updated_at: new Date(),
    };
    const { error } = await supabase.from('notification_settings')
      .upsert(payload, { onConflict: 'user_id,profile_id' });
    if (error) { console.error('saveNotificationSettings:', error); return false; }
    return true;
  } catch(e) { console.error('saveNotificationSettings:', e); return false; }
}
// ─── STORAGE ─────────────────────────────────────────────────────────────────
// Bucket-ul 'documents' e privat: URL-ul stocat în baza de date e doar un identificator
// de cale (format public, stabil), iar pentru afișare/descărcare se generează URL-uri
// SEMNATE, valabile limitat — un link scurs în afara aplicației expiră singur.
const SIGNED_URL_TTL = 60 * 60 * 24; // 24h — regenerate la fiecare încărcare a aplicației

// Extrage calea din bucket dintr-un URL public SAU semnat
function storagePathFromUrl(fileUrl) {
  try {
    const url = new URL(fileUrl);
    const m = url.pathname.match(/\/storage\/v1\/object\/(?:public|sign)\/documents\/(.+)$/);
    return m ? decodeURIComponent(m[1]) : null;
  } catch(e) { return null; }
}

// URL de afișare pentru un fișier: semnat dacă se poate, altfel URL-ul original
export async function getDisplayUrl(fileUrl) {
  if (!fileUrl) return fileUrl;
  const path = storagePathFromUrl(fileUrl);
  if (!path) return fileUrl;
  try {
    const { data, error } = await supabase.storage.from('documents').createSignedUrl(path, SIGNED_URL_TTL);
    if (error || !data?.signedUrl) return fileUrl;
    return data.signedUrl;
  } catch(e) { return fileUrl; }
}

export async function uploadFile(file, session, ownerUserId=null) {
  const E = (typeof window!=="undefined" && window.fmErr) ? window.fmErr : ()=>{};
  try {
    // Fișierul se urcă în folderul profilului pe care lucrăm (owner-ul dacă e profil partajat)
    const userId = effUid(session, ownerUserId);
    if(!userId) { E("uploadFile: nu există userId în sesiune"); return null; }
    if(!file || file.size === 0) { E("uploadFile: fișier gol sau mărime 0"); return null; }
    const path = `${userId}/${Date.now()}_${(file.name||"fisier").replace(/[^a-zA-Z0-9._-]/g,'_')}`;
    const { error } = await supabase.storage.from('documents').upload(path, file, { cacheControl: '3600', upsert: false });
    if (error) { E('uploadFile EROARE storage:', error.message || error); return null; }
    // Întoarce URL-ul în format public — e identificatorul stabil salvat în baza de date
    // (nu expiră); pentru afișare, apelantul folosește getDisplayUrl()
    const { data: urlData } = supabase.storage.from('documents').getPublicUrl(path);
    return urlData?.publicUrl || null;
  } catch(e) { E('uploadFile EXCEPȚIE:', e?.message || e); return null; }
}
export async function deleteFile(fileUrl) {
  try {
    const path = storagePathFromUrl(fileUrl);
    if (!path) return;
    await supabase.storage.from('documents').remove([path]);
  } catch(e) { console.error('deleteFile:', e); }
}
// ─── INVITATIONS ──────────────────────────────────────────────────────────────
export async function createInvitation(session, profileId, invitedEmail, role, shareSettings={}) {
  // Owner-ul nu își poate da acces partajat propriului cont
  const ownerEmail = (session?.user?.email||"").trim().toLowerCase();
  if(ownerEmail && (invitedEmail||"").trim().toLowerCase() === ownerEmail) {
    console.warn('createInvitation: email invitat = email owner, ignorat');
    return null;
  }
  const token = crypto.randomUUID();
  const { data, error } = await supabase.from('invitations').insert({
    user_id: uid(session),
    profile_id: profileId || null,
    invited_email: invitedEmail,
    role,
    share_settings: shareSettings,
    token,
    status: 'pending'
  }).select().maybeSingle();
  if (error) { console.error('createInvitation:', error); return null; }
  return data;
}
// Verifică dacă un email are deja un rol activ (accepted/pending) pe acest profil
export async function getActiveRoleForEmail(session, profileId, invitedEmail) {
  let q = supabase.from('invitations').select('role,status')
    .eq('user_id', uid(session))
    .eq('invited_email', invitedEmail)
    .in('status', ['accepted','pending']);
  if (profileId) q = q.eq('profile_id', profileId);
  else q = q.is('profile_id', null);
  const { data, error } = await q;
  if (error) { console.error('getActiveRoleForEmail:', error); return null; }
  if (data && data.length) return data[0].role;
  return null;
}
// Caută o invitație existentă pentru acest email + profil + rol
export async function findInvitation(session, profileId, invitedEmail, role) {
  let q = supabase.from('invitations').select('*')
    .eq('user_id', uid(session))
    .eq('invited_email', invitedEmail)
    .eq('role', role)
    .order('created_at', { ascending: false });
  if (profileId) q = q.eq('profile_id', profileId);
  else q = q.is('profile_id', null);
  const { data, error } = await q;
  if (error) { console.error('findInvitation:', error); return null; }
  return (data && data.length) ? data[0] : null;
}
// Returnează invitația existentă sau creează una nouă (link o singură dată)
export async function getOrCreateInvitation(session, profileId, invitedEmail, role, shareSettings={}) {
  const existing = await findInvitation(session, profileId, invitedEmail, role);
  if (existing) {
    // Dacă era revocată, o reactivăm
    if (existing.status === 'revoked') {
      await supabase.from('invitations').update({ status: existing.acceptor_user_id ? 'accepted' : 'pending', share_settings: shareSettings }).eq('token', existing.token);
      return { ...existing, status: existing.acceptor_user_id ? 'accepted' : 'pending', _reactivated: true };
    }
    return { ...existing, _existing: true };
  }
  return await createInvitation(session, profileId, invitedEmail, role, shareSettings);
}
// Auto-acceptă invitația dacă persoana are deja cont (via RPC SECURITY DEFINER)
export async function autoAcceptIfUserExists(token) {
  const { data, error } = await supabase.rpc('auto_accept_if_user_exists', { p_token: token });
  if (error) { console.error('autoAccept:', error); return false; }
  return data === true;
}
// Revocă accesul (debifare toggle)
export async function revokeInvitation(session, profileId, invitedEmail, role) {
  const inv = await findInvitation(session, profileId, invitedEmail, role);
  if (!inv) return false;
  const { error } = await supabase.from('invitations').update({ status: 'revoked' }).eq('token', inv.token);
  if (error) { console.error('revokeInvitation:', error); return false; }
  return true;
}
export async function getInvitationByToken(token) {
  const { data, error } = await supabase.from('invitations').select('*').eq('token', token).maybeSingle();
  if (error) { console.error('getInvitation:', error); return null; }
  return data;
}
export async function acceptInvitation(token, acceptorUserId) {
  const { error } = await supabase.from('invitations')
    .update({ status: 'accepted', acceptor_user_id: acceptorUserId })
    .eq('token', token);
  if (error) console.error('acceptInvitation:', error);
  return !error;
}
export async function loadMyAccess(session) {
  // Folosește RPC care aduce și numele profilului + owner_user_id
  const { data, error } = await supabase.rpc('get_my_shared_access', { p_email: session?.user?.email });
  if (error) { console.error('loadMyAccess:', error); return []; }
  return data || [];
}
export async function loadProfileInvitations(session, profileId) {
  let q = supabase.from('invitations').select('*').eq('user_id', uid(session));
  if (profileId) q = q.eq('profile_id', profileId);
  else q = q.is('profile_id', null);
  const { data, error } = await q;
  if (error) { console.error('loadProfileInvitations:', error); return []; }
  return data || [];
}
// ─── TOGGLE ACCES ÎNGRIJITOR ─────────────────────────────────────────────────
export async function setInvitationStatus(token, status) {
  const { error } = await supabase
    .from('invitations')
    .update({ status })
    .eq('token', token);
  if(error) console.error('setInvitationStatus:', error);
  return !error;
}

// ─── FEEDBACK ────────────────────────────────────────────────────────────────
export async function saveFeedback(fb, session) {
  const owner = session?.user?.id || null;
  const { error } = await supabase.from('feedback').insert({
    user_id: owner,
    category: fb.category || 'general',
    message: fb.message,
    rating: fb.rating || null,
    app_context: fb.context || null,
    user_email: session?.user?.email || null,
  });
  if (error) { console.error('saveFeedback:', error); return { error: error.message }; }
  return { success: true };
}
